import { combineReducers } from 'redux';
import createMerchantReducer from '../containers/Shop/CreateMerchant/reducer';
import locationReducer from 'reducers/locationReducer';
import staffReducer from 'reducers/staffReducer';

export default combineReducers({
  createMerchant: createMerchantReducer,
  location: locationReducer,
  staff: staffReducer,
});
